/* tslint:disable */

/**
 */
export class ProdElmtInitTemp {
    isoThermal?: boolean;
    tempPoints?: number[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/prod-elmt-init-temp.ts